
    <fieldmagic-dialog
      icon="plus-circle"
      label="add_checklist"
    >
      <ng-template fieldmagicDialogButtonsTmp>
        <fieldmagic-primary-button
          [label]="isConvert ? 'convert' : 'duplicate'"
          (click)="onSave()"
          [icon]="isConvert ? 'arrow-alt-circle-right' : 'copy'"
        >
        </fieldmagic-primary-button>
        <fieldmagic-primary-button
          variant="error"
          (click)="onCancel()"
          icon="times"
          label="close"
        ></fieldmagic-primary-button>
      </ng-template>

      <ng-template fieldmagicDialogContentTmp>
          <div fieldmagicGridColumn="12">
            <fieldmagic-text-input
              [(ngModel)]="checklistName"
              [withRequiredMarker]="true"
              [label]="'name'"
              [standalone]="false"
            >
            </fieldmagic-text-input>
          </div>

          <ng-container *ngIf="isConvert">
            <div fieldmagicGridColumn="12">
              <fieldmagic-dropdown-input
                [(ngModel)]="checklistType"
                [label]="'checklist_type'"
                [withRequiredMarker]="true"
                [options]="checklistTypeList"
              >
              </fieldmagic-dropdown-input>
            </div>

            <div *ngIf="isAsset" fieldmagicGridColumn="12">
              <span class="fieldmagic-text-input-label fieldmagic-text-with-required-mark">{{ 'asset_type' | translate }}</span>
              <ng-select
                [(ngModel)]="objAssetRelate.value"
                (open)="objAssetRelate.loadDataOnClick()"
                [items]="objAssetRelate.source | async"
                [loading]="objAssetRelate.loader"
                [typeahead]="objAssetRelate.typehead"
                bindLabel="text"
                [ngModelOptions]="{standalone: true}"
                appendTo="body"
                ngDefaultControl
              ></ng-select>
            </div>
          </ng-container>
      </ng-template>
    </fieldmagic-dialog>
  